import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import PublicLayout from "@/components/layout/PublicLayout";
import AdminLayout from "@/components/layout/AdminLayout";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Menu from "@/pages/Menu";
import Commander from "@/pages/Commander";
import Contact from "@/pages/Contact";
import Offres from "@/pages/Offres";
import MentionsLegales from "@/pages/MentionsLegales";
import Allergenes from "@/pages/Allergenes";

import AdminMenu from "@/pages/admin/AdminMenu";
import AdminOffers from "@/pages/admin/AdminOffers";
import AdminParametres from "@/pages/admin/AdminParametres";
import AdminBranding from "@/pages/admin/AdminBranding";
import AdminLegal from "@/pages/admin/AdminLegal";
import AdminAllergens from "@/pages/admin/AdminAllergens";
import AdminAccount from "@/pages/admin/AdminAccount";

import { healthCheck } from "@/lib/api";
import { CartProvider } from "@/lib/cartStore";
import { AdminAuthProvider } from "@/lib/adminAuth";

function App() {
  // Fire a single health probe on load — useful as a quick wiring check.
  useEffect(() => {
    healthCheck().catch((e) => {
      console.warn("Backend health check failed", e?.message);
    });
  }, []);

  return (
    <div className="App">
      <CartProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/menu" element={<Menu />} />
                <Route path="/offres" element={<Offres />} />
                <Route path="/commander" element={<Commander />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="/allergenes" element={<Allergenes />} />
              </Route>

              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminMenu />} />
                <Route path="offres" element={<AdminOffers />} />
                <Route path="logo" element={<AdminBranding />} />
                <Route path="mentions-legales" element={<AdminLegal />} />
                <Route path="allergenes" element={<AdminAllergens />} />
                <Route path="parametres" element={<AdminParametres />} />
                <Route path="compte" element={<AdminAccount />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AdminAuthProvider>
      </CartProvider>
    </div>
  );
}

export default App;
